import React, { useEffect } from 'react'
import { analytics } from 'api/urls'
import { POST } from 'api/request'

interface DamianAnalystProps {
  children: JSX.Element
}

const INTERVAL = 10 * 1000

const DamianAnalyst: React.FC<DamianAnalystProps> = ({ children }) => {
  const sendCurrentUserPosition = async () => {
    try {
      const path = window.location.pathname + window.location.search
      await POST(analytics, { body: { path } })
    } catch (error) {
      console.error(':/')
    }
  }

  useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        sendCurrentUserPosition()
        interval = setInterval(sendCurrentUserPosition, INTERVAL)
      } else {
        clearInterval(interval)
      }
    }
    let interval = setInterval(sendCurrentUserPosition, INTERVAL)
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  return (
    children
  )
}

export default DamianAnalyst